import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@ublend-npm/aulaui-core';
import { getHomeViewRole } from '@app/selectors/home';
import { WidgetCard } from '../../common';
import QuickLinkTile from './QuickLinkTile';
import { QUICK_LINKS } from '../constants/quicklinkConstants';
import useBreakpoints from '@app/hooks/useBreakpoints';

const QuickLinks: React.FC = () => {
  const currentRole = useSelector(getHomeViewRole);
  const [isHidden, setIsHidden] = useState(false);
  const { lg, xl } = useBreakpoints();
  const roleHrefKey = currentRole === 'student' ? 'learner' : 'educator';

  const visibleLinks = QUICK_LINKS.filter((link) => link.href[roleHrefKey]);

  const handleHide = () => {
    setIsHidden(true);
  };

  const menuActions = [{ id: 'hide', label: 'Hide', onClick: handleHide }];

  if (isHidden) return null;

  const isCompact = lg && !xl;

  const content = (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: isCompact ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)',
        columnGap: isCompact ? '8px' : '16px',
        rowGap: '16px',
      }}
    >
      {visibleLinks.map((link) => (
        <QuickLinkTile
          key={link.key}
          link={link}
          role={currentRole}
          isCompact={isCompact}
        />
      ))}
    </Box>
  );

  return (
    <>
      {isCompact && (
        <style>{`
          [data-widget-id='home-quick-links-widget'] {
            flex: 1 1 100% !important;
            max-width: 100% !important;
          }
        `}</style>
      )}
      <WidgetCard
        title="Quick links"
        menuActions={menuActions}
        minHeight="auto"
      >
        {content}
      </WidgetCard>
    </>
  );
};

export default QuickLinks;
